import React, { FC, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Radio } from "antd";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { ReactSVG } from "react-svg";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../helpers/request/RequestPayload";
import { generateUUID } from "utils/appUtil";
import { GET_TICKET_PAGES, SAVE_RECORDING } from "../../../reducers/reducer";

let timeout: NodeJS.Timeout;

const SaveRecordingModal: FC<{
  onClose?: () => void;
  socket?: ISocket;
  workerSid?: string;
}> = ({ onClose, socket, workerSid }) => {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState<boolean>(false);
  const [pages, setPages] = useState<any>([]);
  const [selectedPage, setSelectedPage] = useState<any>();
  const { encrypted_token, projects } = useSelector((state: RootState) => state.auth);
  const { search } = useLocation();

  useEffect(() => {
    if (socket.client) {
      getPages();
    }
  }, [socket.client]);

  const handleCancel = () => {};

  const handleOk = (values: any) => {};

  const getPages = (searchInput = "") => {
    const userId = encrypted_token?.userId;
    const requestData = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
          searchQuery: `@pageMembers:{${userId}}`,
        },
        load: {
          objectId: "$.objectId",
          title: "$.persistent.static.metadata.title",
          updatedAt: "$.persistent.dynamic.updatedAt",
        },
      },
      sortBy: {
        properties: [
          {
            field: "@updatedAt",
            order: "DESC",
          },
        ],
        max: 100000,
      },
      filter: {
        expression:
          searchInput !== ""
            ? `exists(@title) && contains(@title, '${searchInput}')`
            : ``,
      },
      result: {
        pagination: {
          offset: 0,
          limit: 30,
        },
      },
    };
    setSelectedPage(undefined);
    dispatch(
      GET_TICKET_PAGES({
        requestData,
        callback: (response) => {
          setPages(response);
        },
      })
    );
  };

  return (
    <Modal
      title={`Save recording`}
      visible={true}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal scrollable"
      footer={[]}
      destroyOnClose={true}
      closable={false}
    >
      <Row>
        <Col span={24}>
          <Input
            name="title"
            onChange={(e) => {
              const value = e.target.value;
              if (timeout) clearTimeout(timeout);
              timeout = setTimeout(() => {
                console.log("e here", value);
                getPages(value);
              }, 500);
            }}
            placeholder="Search page"
          />
        </Col>
      </Row>

      <Row className="scrollable-body mt-4">
        <Col span={24}>
          <Row className="d-flex mb-4">
            <Col>
              <h5>Select page</h5>
            </Col>
            <Col>
              <Button
                className={`beam-btn w-70`}
                onClick={() => {
                  getPages();
                }}
              >
                Refresh
              </Button>
            </Col>
          </Row>

          <Radio.Group
            className="plain-radios w-100"
            onChange={(e) => {
              setSelectedPage(e.target.value);
            }}
            value={selectedPage}
          >
            {pages &&
              pages.map((page, index) => (
                <Row className="person-item" key={index}>
                  <Col span={4}>
                    <ReactSVG
                      src={`/images/community-blue-icon.svg`}
                      className="colorable mark-icon"
                    />
                  </Col>
                  <Col span={13}>
                    <h5>{page?.title || `Page ${page.objectId}`}</h5>
                  </Col>
                  <Col span={7} className="d-block t-right">
                    <Radio
                      value={page.objectId}
                      className="green-radio"
                    ></Radio>
                  </Col>
                </Row>
              ))}
          </Radio.Group>
        </Col>
      </Row>

      <Row className="action-grp mt-4 sticky-footer">
        <Col span={24} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            loading={saving}
            disabled={selectedPage === undefined}
            onClick={() => {
              const connectionId = encrypted_token?.connectionId;
              const userId = encrypted_token?.userId;
              // socket.publishToEvent(
              //   SocketTopics.PublishPageTopics,
              //   `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/saveTwilioRecording`,
              //   wrapRequestPayload({
                  // connectionId,
                  // workerSid,
                  // userId,
                  // pageId: selectedPage.toString(),
              //   })
              // );

              const requestData = {
                connectionId,
                workerSid,
                userId,
                pageId: selectedPage.toString(),
                userServiceId: projects?.userServiceId
              };
              dispatch(
                SAVE_RECORDING({
                  requestData,
                  callback: (response) => {
                    console.log("save recording response", response);
                  },
                })
              );

              onClose();
            }}
          >
            Save
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default SaveRecordingModal;
